import { render, staticRenderFns } from "./tutorialsList.vue?vue&type=template&id=9cf68560&"
import script from "./tutorialsList.vue?vue&type=script&lang=js&"
export * from "./tutorialsList.vue?vue&type=script&lang=js&"
import style0 from "./tutorialsList.vue?vue&type=style&index=0&id=9cf68560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports